export const CONNECT_COUNTRIES = [
  ["CA", "Canada"], ["US", "United States"], ["GB", "United Kingdom"], ["AU", "Australia"], ["NZ", "New Zealand"],
  ["IE", "Ireland"], ["FR", "France"], ["DE", "Germany"], ["ES", "Spain"], ["IT", "Italy"], ["NL", "Netherlands"],
  ["BE", "Belgium"], ["AT", "Austria"], ["CH", "Switzerland"], ["PT", "Portugal"], ["SE", "Sweden"], ["NO", "Norway"],
  ["DK", "Denmark"], ["FI", "Finland"], ["PL", "Poland"], ["CZ", "Czechia"], ["SK", "Slovakia"], ["SI", "Slovenia"],
  ["HU", "Hungary"], ["RO", "Romania"], ["BG", "Bulgaria"], ["HR", "Croatia"], ["GR", "Greece"], ["CY", "Cyprus"],
  ["MT", "Malta"], ["EE", "Estonia"], ["LV", "Latvia"], ["LT", "Lithuania"], ["LU", "Luxembourg"], ["LI", "Liechtenstein"],
  ["GI", "Gibraltar"], ["JP", "Japan"], ["SG", "Singapore"], ["HK", "Hong Kong"], ["MY", "Malaysia"], ["TH", "Thailand"],
  ["AE", "United Arab Emirates"], ["MX", "Mexico"],
];

export const guessCountryCode = (name) => {
  const hit = CONNECT_COUNTRIES.find(([, n]) => n.toLowerCase() === (name || "").trim().toLowerCase());
  return hit ? hit[0] : "CA";
};
